import { commonPartners } from "./common";
import { Partner } from "./types";
import { cnPartners } from "./zh-CN";
import { hkPartners } from "./zh-HK";
import { twPartners } from "./zh-TW";

export type { LinkItem, Partner } from "./types";

type SupportLocale = "en" | "zh-CN" | "zh-HK" | "zh-TW";

const sortPartners = (partners: readonly Partner[]): readonly Partner[] =>
  [...partners].sort((a, b) => a.id.localeCompare(b.id));

const partnersByLocale: Record<SupportLocale, readonly Partner[]> = {
  en: sortPartners([
    ...commonPartners,
    ...twPartners,
    ...hkPartners,
    ...cnPartners,
  ]),
  "zh-CN": sortPartners([...commonPartners, ...cnPartners]),
  "zh-HK": sortPartners([...commonPartners, ...hkPartners]),
  "zh-TW": sortPartners([...commonPartners, ...twPartners]),
};

const resolveLocale = (locale?: string): SupportLocale => {
  switch (locale?.replace("_", "-").toLowerCase()) {
    case "zh-cn":
      return "zh-CN";
    case "zh-hk":
      return "zh-HK";
    case "zh-tw":
      return "zh-TW";
    default:
      return "en";
  }
};

export const getSupportPartners = (
  locale?: string,
): readonly Partner[] => partnersByLocale[resolveLocale(locale)];
